import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Divider,
  makeStyles,
  Tab,
  Tabs
} from '@material-ui/core';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import TEXTQRCode from '../PopularQRCode/TextQRCode';
import WIFIQRCode from './WIFIQRCode';

const useStyles = makeStyles(() => ({
  root: {}
}));

const OtherQRCode = ({ className, ...rest }) => {
  const history = useHistory();
  const location = useLocation();
  const { tabId } = useParams();
  const [currentTab, setcurrentTab] = useState(0);

  
  const tabs = [
    { value: 0, label: 'WIFI', param: 'free-qrcode-for-wifi' },
    { value: 1, label: 'Location', param: 'free-qrcode-for-location' },
  ];

  useEffect(() => {
    if (tabId === 'free-qrcode-for-wifi') {
      setcurrentTab(0);
    } else if (tabId === 'free-qrcode-for-location') {
      setcurrentTab(1);
    }
  }, [tabId]);


  const handleTabsChange = (event, value) => {
    const param = tabs.find(tab => tab.value === value).param;
    if (param) {
      const newUrl = `/tools/free-qrcode-generator/${param}`;
      history.push(newUrl);
      setcurrentTab(value);
    }
  };
  
  
  
  return (
    <div>
      <Box
        sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex' }}
      >
        <Tabs
          onChange={handleTabsChange}
          scrollButtons="auto"
          value={currentTab}
          variant="scrollable"
          textColor="secondary"
        >
          {tabs.map((tab) => (
            <Tab
              key={tab.value}
              label={tab.label}
              value={tab.value}
            />
          ))}
        </Tabs>
      </Box>
      <Divider />
      <Box mt={5}>
        {currentTab === 0 && <WIFIQRCode text="wifi" qrcodeName="WIFI" />}
        {currentTab === 1 && <TEXTQRCode text="www.apitier.com" qrcodeName="Location" />}
      </Box>
    </div>
  );
};

OtherQRCode.propTypes = {
  className: PropTypes.string
};

export default OtherQRCode;

